/**
 * Decide which `baseTemplateId` to attach to a bulk wishlist invite request.
 *
 * The bulk flow reuses the send-flow template selector for the email/invitation
 * pair. The value sent to the backend follows three states:
 *
 *  - The pair has no library entries: the brand has no email templates, so the
 *    backend-prepared default drives the body. Return `undefined` so the field
 *    is omitted and the legacy behaviour is preserved untouched.
 *  - A brand template is selected: return its id for attribution + snapshot.
 *  - The system default is selected: the selector reports `null` (system
 *    defaults are not attributable), so return `null`.
 *
 * `selectedTemplateId` is the value the selector already resolved through
 * `attributableTemplateId` (brand id, or `null` for a system default).
 */
export const resolveBulkBaseTemplateId = (
  usesLibraryTemplate: boolean,
  selectedTemplateId: string | null
): string | null | undefined => {
  if (!usesLibraryTemplate) {
    return undefined;
  }
  return selectedTemplateId;
};
